import React, { Fragment } from "react";

function VerticalCard({ value, icon, title, iconComponent }) {
  return (
    <div className="col-xl-3 col-md-4  col-sm-6 mb-3 rounded-5">
      <div
        className="custom-card p-2 d-flex flex-column justify-content-around"
        style={{
          backgroundColor: "#fff",
          borderRadius: "18px",
          minHeight: window.screen.width > 575 ? "150px" : "100px",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        }}
      >
        <div className={"d-flex " + (window.screen.width < 768 ? "flex-row-reverse justify-content-center" : "flex-row justify-content-between")}>
          <h6 className="mx-2" style={{ color: "#000" }}>
            {title}
          </h6>
          {
            icon &&
            <i
              style={{ fontSize: "29px", color: "#000" }}
              className={`${icon} mx-2`}
            ></i>
          }
          {iconComponent && iconComponent}
        </div>
        <div></div>
        <div>
          <h1 className="" style={{ color: "#E42A3E", textAlign: 'center', fontSize: window.screen.width < 576 && "25px" }}>
            {value}
          </h1>
        </div>
        {/* <div className="title d-flex">
          <div className="icon">
            <i class={icon}></i>
          </div>
          <div className="text text-white mr-2">
            <h4 className="m-0" style={{ alignSelf: "center" }}>
              {title}
            </h4>
          </div>
        </div>
        <div className="value" style={{ marginTop: "auto" }}>
          <h3 className="text-right text-white">{value}</h3>
        </div> */}
      </div>
    </div>
  );
}

export default VerticalCard;
